module.exports = __webpack_public_path__ + "OpenSans-Light.963eb32907744d9a0d6b.woff";


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/node_modules/npm-font-open-sans/fonts/Light/OpenSans-Light.woff
// module id = ../../../../npm-font-open-sans/fonts/Light/OpenSans-Light.woff
// module chunks = styles